export default __webpack_public_path__ + "static/media/mapMarkerBlue.1e65e0d5.svg";